import React from "react";
import PropTypes from "prop-types";
import { Badge, Tabs } from "@opendate-app/setlist";
import { countOrUndefined } from "../../shared/components/CountBadge";

export const STAFFING_TABS = {
  schedule: "Schedule",
  timesheets: "Timesheets",
  people: "Staff",
  availability: "Availability",
  requests: "Requests",
  settings: "Settings",
};

const AVAILABILITY_BADGES = {
  open: { color: "success", label: "Open" },
  upcoming: { color: "gray", label: "Upcoming" },
  closed: { color: "gray", label: "Closed" },
};

const tabLabel = (value, label, counts) => {
  const badge = value === "availability" && AVAILABILITY_BADGES[counts?.availabilityStatus];
  if (!badge) return label;
  return (
    <span className="d-inline-flex align-items-center" style={{ gap: 6 }}>
      {label}
      <Badge color={badge.color} size="sm">
        {badge.label}
      </Badge>
    </span>
  );
};

export const STAFFING_SUPPORTING_TEXT = "Schedule your team, paid or volunteer, track their hours and keep every shift covered.";

const StaffingTabs = ({ current, paths }) => {
  const items = Object.entries(STAFFING_TABS)
    .filter(([value]) => paths[value])
    .map(([value, label]) => {
      const count = countOrUndefined(paths.counts?.[value]);
      const text = tabLabel(value, label, paths.counts);
      return count ? { value, label: text, count } : { value, label: text };
    });

  return (
    <div className="mb-4">
      <Tabs
        items={items}
        value={current}
        onChange={(value) => {
          if (value !== current) window.location.href = paths[value];
        }}
      />
    </div>
  );
};

export const staffingTabPathsShape = PropTypes.shape({
  schedule: PropTypes.string,
  timesheets: PropTypes.string,
  people: PropTypes.string.isRequired,
  availability: PropTypes.string,
  requests: PropTypes.string,
  settings: PropTypes.string,
  general: PropTypes.string,
  positions: PropTypes.string,
  templates: PropTypes.string,
  permissions: PropTypes.string,
  counts: PropTypes.shape({ requests: PropTypes.number, availabilityStatus: PropTypes.oneOf(Object.keys(AVAILABILITY_BADGES)) }),
});

StaffingTabs.propTypes = {
  current: PropTypes.oneOf(Object.keys(STAFFING_TABS)).isRequired,
  paths: staffingTabPathsShape.isRequired,
};

export default StaffingTabs;
